import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { reLeaseAndContractExpiredClassConfig } from './ReLeaseAndContractExpiredClass.name';

/** 再リース及び満了のENUM */
enum ReLeaseAndContractExpiredClass {
  /** 契約を再リースする */
  contractRelease = '1',
  /** 契約を満了する */
  contractExpired = '2',
}

const reLeaseAndContractExpiredClassMap = new Map([
  ['1', ReLeaseAndContractExpiredClass.contractRelease],
  ['2', ReLeaseAndContractExpiredClass.contractExpired],
]);

function rawValueToReLeaseAndContractExpiredClass(rawValue: string) {
  return rawValueToEnumWithDefault(
    reLeaseAndContractExpiredClassMap,
    ReLeaseAndContractExpiredClass.contractRelease,
  )(rawValue);
}

const reLeaseAndContractExpiredClassToDisplay = enumToNameWithDefault(
  ReLeaseAndContractExpiredClass,
  reLeaseAndContractExpiredClassConfig,
);

export {
  ReLeaseAndContractExpiredClass,
  rawValueToReLeaseAndContractExpiredClass,
  reLeaseAndContractExpiredClassToDisplay,
};
